// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-multiple-sign:before {\n  content: '\\D7';\n}\n", "",{"version":3,"sources":["webpack://./app/EAssessment.UI.Common/app-components/icons/icon/styles/symbols.less"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF","sourcesContent":[".icon-multiple-sign:before {\n  content: '\\D7';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
